// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import ReactMarkdown from "react-markdown";
import * as MediaQuery$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as VehicleStoreEn$PorterinFeature from "../../../core/constants/VehicleStoreEn.mjs";
import * as VehicleCapacityCmp$PorterinFeature from "./VehicleCapacityCmp.mjs";
import * as VehicleDetailsModuleScss from "../styles/VehicleDetails.module.scss";

var styles = VehicleDetailsModuleScss;

function VehicleDetailsCmp(Props) {
  var vehicle = Props.vehicle;
  var title = Props.title;
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  var match = vehicle.best_for_sending.length;
  return React.createElement("section", {
              className: styles["title-container"]
            }, React.createElement("div", {
                  className: styles.vehicle
                }, React.createElement("div", {
                      className: styles["vehicle-image"]
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: vehicle.image_src,
                          height: isDesktop ? 140.0 : 70.0,
                          width: isDesktop ? 226.0 : 113.0,
                          alt: vehicle.alt_text
                        })), React.createElement("div", {
                      className: styles["vehicle-weight-desktop"]
                    }, React.createElement(VehicleCapacityCmp$PorterinFeature.make, {
                          icon: vehicle.capacity_icon,
                          capacity: vehicle.capacity
                        })), React.createElement("div", {
                      className: styles["vehicle-text"]
                    }, React.createElement("h3", {
                          className: styles["vehicle-name"]
                        }, vehicle.vehicle_name), React.createElement("div", {
                          className: styles["vehicle-fare"]
                        }, React.createElement(ReactMarkdown, {
                              children: vehicle.vehicle_fare
                            })), React.createElement("div", {
                          className: styles["vehicle-weight-mobile"]
                        }, React.createElement(VehicleCapacityCmp$PorterinFeature.make, {
                              icon: vehicle.capacity_icon,
                              capacity: vehicle.capacity
                            })))), match !== 0 ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: styles.divider
                      }), React.createElement("div", {
                        className: styles["best-for-section-wrapper"]
                      }, React.createElement("h3", {
                            className: styles["best-for-section-title"]
                          }, VehicleStoreEn$PorterinFeature.vehicle_details_best_for), React.createElement("div", {
                            className: styles["best-for-wrapper"]
                          }, vehicle.best_for_sending.map(function (data) {
                                return React.createElement("div", {
                                            className: styles["best-for"]
                                          }, React.createElement("div", {
                                                className: styles["best-for-image"]
                                              }, React.createElement(NextImage$PorterinFeature.make, {
                                                    src: data.image.path,
                                                    height: 20.0,
                                                    width: 20.0,
                                                    alt: data.image.alt_text
                                                  })), React.createElement("p", {
                                                className: styles["best-for-title"]
                                              }, data.category));
                              })))) : null, React.createElement("div", {
                  className: styles["divider-mobile"]
                }), React.createElement("h2", {
                  className: styles["title-mobile"]
                }, title));
}

var make = VehicleDetailsCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
